import React from 'react';

interface SuccessScreenProps {
  name: string;
  attendance: string;
}

const attendanceLabel: Record<string, string> = {
  engagement: 'the Engagement in Bhopal',
  wedding: 'the Wedding in Warud',
  both: 'both the Engagement and Wedding',
};

export default function SuccessScreen({
  name,
  attendance,
}: SuccessScreenProps) {
  const firstName = name.split(' ')[0];
  const eventLabel = attendanceLabel[attendance] ?? 'the celebrations';

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 py-16"
      style={{ backgroundColor: 'var(--background)' }}
    >
      <div
        className="w-full max-w-lg rounded-2xl p-10 md:p-14 text-center shadow-lg success-enter"
        style={{ backgroundColor: 'var(--card)' }}
      >
        <div className="text-6xl mb-6 heart-pulse inline-block">❤️</div>

        <p
          className="text-sm font-semibold tracking-widest uppercase mb-3"
          style={{ color: 'var(--primary)' }}
        >
          #Vimi
        </p>

        <h1
          className="font-display text-3xl md:text-4xl font-semibold mb-4"
          style={{ color: 'var(--foreground)' }}
        >
          Thank you, {firstName}!
        </h1>

        <p
          className="text-base leading-relaxed mb-6"
          style={{ color: 'var(--muted-foreground)' }}
        >
          Your RSVP for{' '}
          <span style={{ color: 'var(--foreground)', fontWeight: 600 }}>
            {eventLabel}
          </span>{' '}
          has been received. We&apos;re so happy you&apos;ll be celebrating
          with us!
        </p>

        <div
          className="rounded-xl p-5 mb-6 text-sm leading-relaxed"
          style={{
            backgroundColor: 'var(--background)',
            borderLeft: '4px solid var(--primary)',
            color: 'var(--muted-foreground)',
            textAlign: 'left',
          }}
        >
          <strong style={{ color: 'var(--foreground)' }}>
            What happens next?
          </strong>
          <br />
          Vikas &amp; Anamika will be in touch with more details about your
          accommodation and travel arrangements closer to the event. Keep an
          eye on your WhatsApp!
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <div
            className="flex-1 rounded-xl p-4 text-center"
            style={{ backgroundColor: 'var(--background)' }}
          >
            <p className="font-display text-base font-semibold mb-1">
              💍 Engagement
            </p>
            <p
              className="text-sm"
              style={{ color: 'var(--muted-foreground)' }}
            >
              31 December 2026
            </p>
            <p
              className="text-sm"
              style={{ color: 'var(--muted-foreground)' }}
            >
              Bhopal, MP
            </p>
          </div>
          <div
            className="flex-1 rounded-xl p-4 text-center"
            style={{ backgroundColor: 'var(--background)' }}
          >
            <p className="font-display text-base font-semibold mb-1">
              ❤️ Wedding
            </p>
            <p
              className="text-sm"
              style={{ color: 'var(--muted-foreground)' }}
            >
              4 January 2027
            </p>
            <p
              className="text-sm"
              style={{ color: 'var(--muted-foreground)' }}
            >
              Warud, Maharashtra
            </p>
          </div>
        </div>

        <p
          className="mt-8 text-sm"
          style={{ color: 'var(--muted-foreground)' }}
        >
          With love,
          <br />
          <span
            className="font-display text-base font-semibold"
            style={{ color: 'var(--foreground)' }}
          >
            Vikas &amp; Anamika
          </span>
        </p>
      </div>
    </div>
  );
}